import React, { useEffect, useState } from 'react';
import { hooks, models } from '@vote4dance/judging-sdk';
var useSession = hooks.sessions.useSession;
var Stream = hooks.streams.Stream;
var FloorSource = models.floors.FloorSource;
var SessionState = hooks.sessions.SessionState;
import { _T } from "../../../../../base-react/src/Localization";
import { ApplicationStatusDot } from '../../../../components/ApplicationStatusDot';
import { Button, Card, Form, Input, Select, Space, Switch, Divider } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
import ImageUpload from '../../../../../base-react/components/ImageUpload';
import { matchPath } from 'react-router-dom';
// defaults = all hidden = false (so we show by default)
const DEFAULT_SETTINGS = {
    hideNamesPrelim: false
};
function parseSettings(src) {
    try {
        if (!src)
            return { ...DEFAULT_SETTINGS };
        if (typeof src === 'string')
            return { ...DEFAULT_SETTINGS, ...JSON.parse(src) };
        if (typeof src === 'object')
            return { ...DEFAULT_SETTINGS, ...src };
        return { ...DEFAULT_SETTINGS };
    }
    catch {
        return { ...DEFAULT_SETTINGS };
    }
}
function cleanSettings(settings) {
    const cleaned = {};
    for (const key in settings) {
        if (settings[key] !== DEFAULT_SETTINGS[key]) {
            cleaned[key] = settings[key];
        }
    }
    return cleaned;
}
export const ScreenCard = (props) => {
    const { item, onDeleteItem, onEditItem, onChangePicture, connected = false, disabled } = props;
    const sessionState = useSession();
    const [isLoading, setIsLoading] = useState(false);
    const [floors, loadingFloors] = Stream(FloorSource(item.competition_id));
    const isSystemAdministrator = SessionState.isSystemAdministrator(sessionState);
    const [form] = Form.useForm();
    useEffect(() => { form === null || form === void 0 ? void 0 : form.resetFields(); }, []);
    useEffect(() => {
        if (form && item) {
            const match = matchPath({ path: "/event/:event_id/:screen_id/:floor_id/:type" }, item.screen_url);
            const parsed = parseSettings(item.screen_settings);
            form.setFieldsValue({
                ...item,
                floor_id: (match === null || match === void 0 ? void 0 : match.params.floor_id) || 'all',
                type: match === null || match === void 0 ? void 0 : match.params.type,
                screen_settings: parsed
            });
        }
    }, [item]);
    const onFinish = async (values) => {
        const url = `/event/${item.competition_id}/${values.screen_id}/${values.floor_id}/${values.type}`;
        const cleaned = cleanSettings(values.screen_settings || {});
        const screen_settings = Object.keys(cleaned).length ? JSON.stringify(cleaned) : null;
        setIsLoading(true);
        await onEditItem({ ...item, ...values, screen_url: url, screen_settings });
        setIsLoading(false);
    };
    const formItemLayout = { labelCol: { span: 8 }, wrapperCol: { span: 16 } };
    const settingsItemLayout = { labelCol: { span: 22 }, wrapperCol: { span: 2 } };
    return (React.createElement(Card, { style: { width: '100%', maxWidth: 560 }, loading: loadingFloors },
        React.createElement(Form, { name: "screen_item", ...formItemLayout, form: form, onFinish: onFinish, disabled: disabled, labelAlign: "left", style: { width: '100%' } },
            React.createElement(Form.Item, { name: "screen_label", label: _T('screen.details.screen_label.label') },
                React.createElement(Input, null)),
            React.createElement(Form.Item, { name: "screen_target", label: _T('screen.details.screen_target.label') },
                React.createElement(Select, { options: [
                        { value: '0', label: _T('screen.targets.0') },
                        { value: '1', label: _T('screen.targets.1') },
                        { value: '2', label: _T('screen.targets.2'), disabled: !isSystemAdministrator },
                        { value: '3', label: _T('screen.targets.3') },
                        { value: '4', label: _T('screen.targets.4') }
                    ] })),
            React.createElement(Form.Item, { noStyle: true, shouldUpdate: (prev, cur) => prev.screen_target !== cur.screen_target }, ({ getFieldValue }) => (React.createElement(Form.Item, { name: 'image_id', label: _T('image.title'), hidden: getFieldValue('screen_target') != '2' },
                React.createElement(ImageUpload, { value: item.image_id, onChange: (imageData) => onChangePicture(item, imageData) })))),
            React.createElement(Form.Item, { name: "floor_id", label: _T('round.details.floor_id.label') },
                React.createElement(Select, { options: [
                        { value: 'all', label: _T('floor.all') },
                        floors ? floors.map(floorItem => ({ value: floorItem.floor_id, label: floorItem.floor_name || _T('screen.details.floor_id.default') })) : []
                    ].flat() })),
            React.createElement(Form.Item, { name: "type", label: _T('screen.type.title') },
                React.createElement(Select, { options: [
                        { value: 'heat', label: _T('screen.type.heat') },
                        { value: 'lineup', label: _T('screen.type.lineup') },
                        { value: 'result', label: _T('screen.type.result') },
                        { value: 'beat', label: _T('screen.type.beat') },
                        { value: 'last-results', label: _T('screen.type.last-results') }
                    ] })),
            React.createElement(Divider, { style: { margin: '12px 0' } }, _T('common.settings')),
            React.createElement(Form.Item, { ...settingsItemLayout, name: ['screen_settings', 'hideNamesPrelim'], label: _T('screen.details.screen_settings.hide-names-prelim'), valuePropName: "checked" },
                React.createElement(Switch, null)),
            React.createElement(Form.Item, { wrapperCol: { span: 22, offset: 2 } },
                React.createElement(Space, null,
                    React.createElement(Button, { type: "primary", htmlType: "submit", loading: isLoading }, _T('common.save')),
                    React.createElement(ButtonConfirm, { title: _T('common.delete.title', { name: _T('screen.title').toLowerCase() }), description: _T('common.delete.content', { name: item.screen_label }), onConfirm: (done) => onDeleteItem(item, done), buttonProps: {
                            label: _T('common.delete.title'),
                            type: 'dashed',
                            danger: true,
                            disabled: disabled || isLoading,
                            icon: React.createElement(DeleteOutlined, null)
                        } }),
                    React.createElement(ApplicationStatusDot, { connected: connected, screenId: item.screen_id }))))));
};
